/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { KnowledgeBaseQaPairStatus } from 'uplisting-frontend/models/ai-knowledge-base-qa-pair';

interface IArgs {
  qaPair: ModelRegistry['ai-knowledge-base-qa-pair'];
  onClick(): void;
  onDelete(): void;
  onStatusChange(status: KnowledgeBaseQaPairStatus): void;
  onViewSource(): void;
}

interface QaPairCardSignature {
  Element: HTMLDivElement;
  Args: IArgs;
}

export default class UiKnowledgeCenterQaPairCardComponent extends Component<QaPairCardSignature> {
  statusActive = KnowledgeBaseQaPairStatus.active;
  statusNotUsed = KnowledgeBaseQaPairStatus.notUsed;

  get statusClass(): string {
    const { qaPair } = this.args;

    if (qaPair.isApproved) return 'status-active';
    if (qaPair.isNotUsed) return 'status-not-used';

    return 'status-needs-review';
  }

  @action
  handleActionsClick(event: MouseEvent): void {
    event.stopPropagation();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::KnowledgeCenter::QaPairCard': typeof UiKnowledgeCenterQaPairCardComponent;
  }
}
